import React, { useState } from "react";
import classes from "../style/Style.module.css";
import axios from "../libs/axiosConfig";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  ROUTE_PAN_VERIFICATION,
  ROUTE_CHECKBOXES,
  ROUTE_NOMINEE_SENDOTP,
  ROUTE_CUSTOMER_SUPPORT_SCREEN,ROUTE_NOMINEE_DETAILS,
  ROUTE_ACCOUNT_TYPE,Gender_Dob_Verification,Address_Verification,ROUTE_OCCUPATION,ROUTE_PLACEOF_BIRTH
} from "../Routes";
import { useSelector } from "react-redux";
import Toast from "../Components/ToastMsg/Toast";
import { selectPhoneNumber } from "../Store/MobileSlice";
import { useLocation, useNavigate } from "react-router-dom";
// import { setBankName } from "../Store/UserBankSlice";
import { selectRefreshToken } from "../Store/Token/refreshTokenSlice";
// import { setIinNumber } from "../Store/IINSlice";
import { useDispatch} from "react-redux";
import "../style/Purchase.scss"

const KycRejected = () => {
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const panNumber = useSelector((state) => state.panNumber.value);
  const [panNumberInput, setPanNumberInput] = useState("");
  const Navigate = useNavigate();
  const phoneNumber = useSelector(selectPhoneNumber);
  const location = useLocation();
  const { fullName } = location.state || {};
  const refreshToken = useSelector(selectRefreshToken);
  const dispatch = useDispatch();
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    setPanNumberInput(e.target.value);
  };

  const handleClearButtonClick = () => {
    setPanNumberInput("");
  };

  const HandleBack = () => {
    Navigate(ROUTE_PAN_VERIFICATION);
  };

  const callAPI = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken

      };

      const thirdApiResponse = await axios.post(
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        {
          CustomerKycDetails: {
            request_type: "get",
            mobileNumber: phoneNumber,
            pan: panNumber,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            // RefreshToken: refreshToken
          },
        }
      );

      console.log(thirdApiResponse);
      const customerKycApiResponse = await axios.get(
        "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",

        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            // RefreshToken: refreshToken,
          },
        }
      );

      const dexterrDetails = customerKycApiResponse.data.data;

      if (
        thirdApiResponse.data.statusCode === 200 &&
        thirdApiResponse.data.status === true &&
        customerKycApiResponse.data.status === true &&
        customerKycApiResponse.data.statusCode === 200
      ) {
        const { bankVerified, nomineeVerified } =
          thirdApiResponse.data.body;
        setApiCallsInProgress(apiCallsInProgress - 1);

        if (
          thirdApiResponse.data.body.bankAccountNumber === "" ||
          customerKycApiResponse.data.data.bankAccountNumber === " " ||
          customerKycApiResponse.data.data.bankAccountNumber === null ||
          thirdApiResponse.data.body.bankIfscCode === "" ||
          customerKycApiResponse.data.data.bankIfscCode === " " ||
          customerKycApiResponse.data.data.bankIfscCode === null ||
          thirdApiResponse.data.body.bankAccountType === "" ||
          customerKycApiResponse.data.data.bankAccountType === " " ||
          customerKycApiResponse.data.data.bankAccountType === null ||
          thirdApiResponse.data.body.bankName === "" ||
          customerKycApiResponse.data.data.bankName === " " ||
          customerKycApiResponse.data.data.bankName === null ||
          thirdApiResponse.data.body.bankBranchName === "" ||
          customerKycApiResponse.data.data.bankBranchName === " " ||
          customerKycApiResponse.data.data.bankBranchName === null ||
          thirdApiResponse.data.body.bankBranchAddress === "" ||
          customerKycApiResponse.data.data.bankBranchAddress === " " ||
          customerKycApiResponse.data.data.bankBranchAddress === null ||
          thirdApiResponse.data.body.bankCodeNSE === "" ||
          customerKycApiResponse.data.data.bankCodeNSE === " " ||
          customerKycApiResponse.data.data.bankCodeNSE === null ||
          thirdApiResponse.data.body.bankCodeBillDesk === "" ||
          customerKycApiResponse.data.data.bankCodeBillDesk === " " ||
          customerKycApiResponse.data.data.bankCodeBillDesk === null ||
          thirdApiResponse.data.body.bankAccountHolderName === "" ||
          customerKycApiResponse.data.data.bankAccountHolderName === " " ||
          customerKycApiResponse.data.data.bankAccountHolderName === null
        ) {
          Navigate(ROUTE_ACCOUNT_TYPE);
        } else if (
          (thirdApiResponse.data.body.bankAccountNumber !== "" ||
            customerKycApiResponse.data.data.bankAccountNumber !== " " ||
            customerKycApiResponse.data.data.bankAccountNumber !== null ||
            thirdApiResponse.data.body.bankIfscCode !== "" ||
            customerKycApiResponse.data.data.bankIfscCode !== " " ||
            customerKycApiResponse.data.data.bankIfscCode !== null ||
            thirdApiResponse.data.body.bankAccountType !== "" ||
            customerKycApiResponse.data.data.bankAccountType !== " " ||
            customerKycApiResponse.data.data.bankAccountType !== null ||
            thirdApiResponse.data.body.bankName !== "" ||
            customerKycApiResponse.data.data.bankName !== " " ||
            customerKycApiResponse.data.data.bankName !== null ||
            thirdApiResponse.data.body.bankBranchName !== "" ||
            customerKycApiResponse.data.data.bankBranchName !== " " ||
            customerKycApiResponse.data.data.bankBranchName !== null ||
            thirdApiResponse.data.body.bankBranchAddress !== "" ||
            customerKycApiResponse.data.data.bankBranchAddress !== " " ||
            customerKycApiResponse.data.data.bankBranchAddress !== null ||
            thirdApiResponse.data.body.bankCodeNSE !== "" ||
            customerKycApiResponse.data.data.bankCodeNSE !== " " ||
            customerKycApiResponse.data.data.bankCodeNSE !== null ||
            thirdApiResponse.data.body.bankCodeBillDesk !== "" ||
            customerKycApiResponse.data.data.bankCodeBillDesk !== " " ||
            customerKycApiResponse.data.data.bankCodeBillDesk !== null ||
            thirdApiResponse.data.body.bankAccountHolderName !== "" ||
            customerKycApiResponse.data.data.bankAccountHolderName !==
            " " ||
            customerKycApiResponse.data.data.bankAccountHolderName !==
            null) &&
          (thirdApiResponse.data.body.bankVerified.account_exists !==
            "True" ||
            thirdApiResponse.data.body.bankVerified.message !== "success" ||
            customerKycApiResponse.data.data.bankVerified === null ||
            Object.keys(customerKycApiResponse.data.data.bankVerified)
              .length === 0 ||
            customerKycApiResponse.data.data.bankVerified.account_exists !==
            "True" ||
            customerKycApiResponse.data.data.bankVerified.message !==
            "success")
        ) {
          Navigate(ROUTE_ACCOUNT_TYPE);
        } else if (
          thirdApiResponse.data.body.panDetails.gender === "" ||
          customerKycApiResponse.data.data.gender === " " ||
          customerKycApiResponse.data.data.gender === null ||
          thirdApiResponse.data.body.panDetails.title === "" ||
          customerKycApiResponse.data.data.title === " " ||
          customerKycApiResponse.data.data.title === null ||
          thirdApiResponse.data.body.panDetails.dob === "" ||
          customerKycApiResponse.data.data.dob === " " ||
          customerKycApiResponse.data.data.dob === null ||
          customerKycApiResponse.data.data.dob === "1900-01-01" ||
                customerKycApiResponse.data.data.dob === "0001-01-01"
        ) {
          Navigate(Gender_Dob_Verification);
        } else if (
          thirdApiResponse.data.body.panDetails.addr1 === "" ||
          customerKycApiResponse.data.data.addressLine1 === " " ||
          customerKycApiResponse.data.data.addressLine1 === null ||
          thirdApiResponse.data.body.panDetails.addr2 === "" ||
          customerKycApiResponse.data.data.addressLine2 === " " ||
          customerKycApiResponse.data.data.addressLine2 === null ||
          thirdApiResponse.data.body.panDetails.city === "" ||
          customerKycApiResponse.data.data.city === " " ||
          customerKycApiResponse.data.data.city === null ||
          thirdApiResponse.data.body.panDetails.state === "" ||
          customerKycApiResponse.data.data.state === " " ||
          customerKycApiResponse.data.data.state === null ||
          thirdApiResponse.data.body.panDetails.pincode === "" ||
          customerKycApiResponse.data.data.zip === " " ||
          customerKycApiResponse.data.data.zip === null ||
          thirdApiResponse.data.body.panDetails.country === "" ||
          customerKycApiResponse.data.data.country === " " ||
          customerKycApiResponse.data.data.country === null ||
          thirdApiResponse.data.body.panDetails.fullAddress === "" ||
          customerKycApiResponse.data.data.fullAddress === " " ||
          customerKycApiResponse.data.data.fullAddress === null
        ) {
          Navigate(Address_Verification);
        } else if (
          thirdApiResponse.data.body.nseIncomeCode === "" ||
          customerKycApiResponse.data.data.nseIncomeCode === " " ||
          customerKycApiResponse.data.data.nseIncomeCode === null ||
          thirdApiResponse.data.body.nseIncomeCodeDescription === "" ||
          customerKycApiResponse.data.data.nseIncomeCodeDescription ===
          " " ||
          customerKycApiResponse.data.data.nseIncomeCodeDescription ===
          null ||
          thirdApiResponse.data.body.nseOccupationCode === "" ||
          customerKycApiResponse.data.data.nseOccupationCode === " " ||
          customerKycApiResponse.data.data.nseOccupationCode === null ||
          thirdApiResponse.data.body.nseOccupationCodeDescription === "" ||
          customerKycApiResponse.data.data.nseOccupationCodeDescription ===
          " " ||
          customerKycApiResponse.data.data.nseOccupationCodeDescription ===
          null
        ) {
          Navigate(ROUTE_OCCUPATION);
        } else if (
          thirdApiResponse.data.body.placeOfBirth === "" ||
          customerKycApiResponse.data.data.placeOfBirth === " " ||
          customerKycApiResponse.data.data.placeOfBirth === null ||
          thirdApiResponse.data.body.nseCountryCodeOfBirth === "" ||
          customerKycApiResponse.data.data.nseCountryCodeOfBirth === " " ||
          customerKycApiResponse.data.data.nseCountryCodeOfBirth === null ||
          thirdApiResponse.data.body.nseCountryOfBirth === "" ||
          customerKycApiResponse.data.data.nseCountryOfBirth === " " ||
          customerKycApiResponse.data.data.nseCountryOfBirth === null
        ) {
          Navigate(ROUTE_PLACEOF_BIRTH);
        } else if (
          thirdApiResponse.data.body.politicallyExposedPerson === "" ||
          customerKycApiResponse.data.data.politicallyExposedPerson ===
          " " ||
          customerKycApiResponse.data.data.politicallyExposedPerson ===
          null ||
          thirdApiResponse.data.body.relatedToPoliticallyExposedPerson ===
          "" ||
          customerKycApiResponse.data.data
            .relatedToPoliticallyExposedPerson === " " ||
          customerKycApiResponse.data.data
            .relatedToPoliticallyExposedPerson === null
        ) {
          Navigate(ROUTE_CHECKBOXES);
        } else if (
          ((thirdApiResponse.data.body.nomineeDob !== "" &&
            customerKycApiResponse.data.data.nomineeDob !== null) &&
            thirdApiResponse.data.body.nomineeName === "") &&
          customerKycApiResponse.data.data.nomineeName === null
        ) {
          
          Navigate(ROUTE_NOMINEE_DETAILS);
        } else if (
          ((thirdApiResponse.data.body.nomineeName !== "" &&
            customerKycApiResponse.data.data.nomineeName !== null) &&
            thirdApiResponse.data.body.nomineeDob === "") &&
          customerKycApiResponse.data.data.nomineeDob === null
        ) {
          
          Navigate(ROUTE_NOMINEE_DETAILS);
        } else if (
          (thirdApiResponse.data.body.nomineeName !== "" &&
          thirdApiResponse.data.body.nomineeType !== "" &&
          thirdApiResponse.data.body.nomineeRelationShip !== "" &&
          thirdApiResponse.data.body.nomineeDob !== "" &&
            customerKycApiResponse.data.data.nomineeName !== null &&
            customerKycApiResponse.data.data.nomineeRelationShip !== null &&
              customerKycApiResponse.data.data.nomineeDob !== "1900-01-01" &&
              customerKycApiResponse.data.data.nomineeDob !== "0001-01-01" ) &&
          (thirdApiResponse.data.body.nomineeVerified === "N" &&
            customerKycApiResponse.data.data.nomineeVerified === "N")
        ) {
          console.log("first");
          Navigate(ROUTE_NOMINEE_SENDOTP);
        }
        // else if (thirdApiResponse.data.body.nomineeName !== "" || customerKycApiResponse.data.data.nomineeName !== " " || customerKycApiResponse.data.data.nomineeName !== null ||
        //   thirdApiResponse.data.body.nomineeRelationShip !== "" || customerKycApiResponse.data.data.nomineeRelationShip !== " " || customerKycApiResponse.data.data.nomineeRelationShip !== null ||
        //   thirdApiResponse.data.body.nomineeAllocationPercentage !== "" || customerKycApiResponse.data.data.nomineeAllocationPercentage !== " " || customerKycApiResponse.data.data.nomineeAllocationPercentage !== null ||
        //   thirdApiResponse.data.body.nomineeDob !== "" || customerKycApiResponse.data.data.nomineeDob !== " " || customerKycApiResponse.data.data.nomineeDob !== null

        //   && (thirdApiResponse.data.body.nomineeGuardianName !== "" || customerKycApiResponse.data.data.nomineeGuardianName !== "" || customerKycApiResponse.data.data.nomineeGuardianName !== null || thirdApiResponse.data.body.nomineeGuardianPan !== "" || customerKycApiResponse.data.data.nomineeGuardianPan !== "" || customerKycApiResponse.data.data.nomineeGuardianPan !== null
        //   )

        //   && (thirdApiResponse.data.body.nomineeVerified === "N" || customerKycApiResponse.data.data.nomineeVerified === "N")) {
        //   Navigate(ROUTE_NOMINEE_SENDOTP)
        // }
        // else {
        //   // Call the second API
        //   const nseIINDetailsAPI = await axios.post(
        //     "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        //     {
        //       nseIINDetails: {
        //         pan: panNumber,
        //       },
        //     }
        //   );
        //   if (
        //     nseIINDetailsAPI.status === 200 &&
        //     nseIINDetailsAPI.data.statusCode === 200
        //   ) {
        //     const nseIINDetailsAPIData = nseIINDetailsAPI.data;
        //     console.log("nseIINDetails api call");
        //     // Toast.success(FristApiResponseData.message);
        //     setApiCallsInProgress(apiCallsInProgress - 1);

        //     if (nseIINDetailsAPI.data && nseIINDetailsAPI.data.body) {
        //       const {
        //         iin,
        //         primary_distributor,
        //         iin_confirmation_status,
        //         iin_consolidated_confirmation_status,
        //         iin_deactivation_reason,
        //       } = nseIINDetailsAPI.data.body || {};
        //       dispatch(setIinNumber(iin));

        //       if (
        //         nseIINDetailsAPI.data.body.iin !== "" &&
        //         nseIINDetailsAPI.data.body.iin_confirmation_status ===
        //           "Y" &&
        //         nseIINDetailsAPI.data.body
        //           .iin_consolidated_confirmation_status === "Y" &&
        //         nseIINDetailsAPI.data.body.activation_Status === "YES"
        //       ) {
        //         const requestBody = {
        //           nseFatcaEnquiry: {
        //             iin: iin,
        //             pan: panNumber,
        //           },
        //         };
        //         console.log("in nseIIN api frist condition work");
        //         try {
        //           const nseFatcaEnquiryresponse = await axios.post(
        //             "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        //             requestBody
        //           );

        //           console.log(nseFatcaEnquiryresponse.data.body);

        //           if (
        //             nseFatcaEnquiryresponse.data.body.status === "Success"
        //           ) {
        //             if (
        //               nseFatcaEnquiryresponse.data.body.fatca_reg ===
        //                 "Y" 
        //                 // && nseFatcaEnquiryresponse.data.body.fatca_verify_status === "Y"
        //             ) {
        //               console.log("in nseIIN api 1nd condition work");

        //               Navigate(ROUTE_Purchase_One_Time, {
        //                 state: {
        //                   IIN_Number: iin,
        //                 },
        //               });
        //             } else if (
        //               nseFatcaEnquiryresponse.data.body.fatca_reg !== "Y"
        //             ) {
        //               console.log("in nseIIN api 2nd condition work");

        //               const CustomerKycDetailsResponse = await axios.get(
        //                 "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",
        //                 {
        //                   headers: {
        //                     Authorization: `Bearer ${storedToken}`,
        //                     // RefreshToken: refreshToken,
        //                   },
        //                 }
        //               );

        //               const GetAPIData =
        //                 CustomerKycDetailsResponse.data.data;
        //               const fullname = GetAPIData.fullName;
        //               dispatch(
        //                 setBankName({ bankName: GetAPIData.bankName })
        //               );
        //               console.log(GetAPIData, "Get api data");

        //               const FatcaApiResponse = await axios.post(
        //                 "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        //                 {
        //                   nseFatca: {
        //                     mobilenumber: phoneNumber,
        //                     pan: panNumber,
        //                     iin: iin,
        //                     investor_name: fullname,
        //                     app_income_code: GetAPIData.nseIncomeCode,
        //                     occ_code: GetAPIData.nseOccupationCode,
        //                     dob: GetAPIData.dob,
        //                     log_name: GetAPIData.emailId,
        //                     country_of_birth:
        //                       GetAPIData.nseCountryOfBirth,
        //                     place_birth: GetAPIData.placeOfBirth,
        //                   },
        //                 },
        //                 {
        //                   headers: {
        //                     Authorization: `Bearer ${storedToken}`,
        //                     // RefreshToken: refreshToken,
        //                   },
        //                 }
        //               );

        //               if (
        //                 FatcaApiResponse.data.status === "true" &&
        //                 FatcaApiResponse.data.statusCode === 200 &&
        //                 FatcaApiResponse.data.body.status === "Success"
        //               ) {
        //                 console.log("in nseIIN api 3rd condition work");
        //                 setApiCallsInProgress(apiCallsInProgress - 1);

        //                 const recheckresponse = await axios.post(
        //                   "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        //                   requestBody
        //                 );
        //                 const { nseFatcaEnquiryData } =
        //                   recheckresponse.data;
        //                 const { status, nseFatcaEnquiry } =
        //                   nseFatcaEnquiryData;

        //                 if (status === "Success") {
        //                   if (
        //                     nseFatcaEnquiry.fatca_reg === "Y" 
        //                     // && nseFatcaEnquiry.fatca_verify_status === "Y"
        //                   ) {
        //                     Navigate(ROUTE_Purchase_One_Time, {
        //                       state: {
        //                         IIN_Number: iin,
        //                       },
        //                     });
        //                   }
        //                 } else {
        //                   if (status !== "Success") {
        //                     Toast.error(
        //                       nseFatcaEnquiryresponse.data.errorMessage ||
        //                         "Failed"
        //                     );
        //                     console.log("1");
        //                   }
        //                 }

        //                 // Navigate(ROUTE_Purchase_One_Time);
        //               } else {
        //                 Toast.error(FatcaApiResponse.data.errorMessage || FatcaApiResponse.data.message);
        //                 console.log("2");
        //                 Navigate(ROUTE_FATCA_Failed);
        //                 setApiCallsInProgress(apiCallsInProgress - 1);
        //               }
        //             } 
        //             // else if (
        //             //   nseFatcaEnquiryresponse.data.body.fatca_reg ===
        //             //     "Y" 
        //             //     // && nseFatcaEnquiryresponse.data.body
        //             //     // .fatca_verify_status !== "Y"
        //             // ) {
        //             //   Navigate(ROUTE_FATCA_CONFIRMATION);
        //             // }
        //           } else {
        //             if (
        //               nseFatcaEnquiryresponse.body.status !== "Success"
        //             ) {
        //               Toast.error(
        //                 nseFatcaEnquiryresponse.data.errorMessage ||
        //                   "Failed"
        //               );
        //               console.log("3");
        //             }
        //           }
        //         } catch (error) {
        //           console.error("Error:", error);
        //           // Handle error
        //         }
        //         // NseFatcaEnquiryapi();
        //         console.log("NseFatcaEnquiryapi call");
        //       } else if (
        //         (nseIINDetailsAPI.data.body.iin !== "" &&
        //           nseIINDetailsAPI.data.body.valid_pan_response === "Y" &&
        //           nseIINDetailsAPI.data.body.iin_confirmation_status ===
        //             "Y" &&
        //           nseIINDetailsAPI.data.body
        //             .iin_consolidated_confirmation_status === "Y" &&
        //           nseIINDetailsAPI.data.body.activation_Status === "NO" &&
        //           nseIINDetailsAPI.data.body.iin_deactivation_reason ===
        //             "Cancelled cheque image not available") ||
        //         "Cancelled cheque image not available,Name mismatch with KYC"
        //       ) {
        //         //console.log(
        //         //   "Navigating to ROUTE_UPLOAD_CANCELLED_CHEQUE"
        //         // );
        //         Navigate(ROUTE_UPLOAD_CANCELLED_CHEQUE);
        //       } else if (iin !== "" && primary_distributor !== "Y") {
        //         Navigate(ROUTE_Purchase_One_Time, {
        //           state: {
        //             IIN_Number: iin,
        //           },
        //         });
        //       } else if (
        //         (primary_distributor === "Y" &&
        //           iin_consolidated_confirmation_status !== "Y") ||
        //         iin_confirmation_status !== "Y"
        //       ) {
        //         Navigate(ROUTE_BLANK_TEXT_SCREEN, {
        //           state: {
        //             INV_Name:
        //               customerKycApiResponse.data.body.panDetails
        //                 .inv_name,
        //           },
        //         });
        //       } else if (
        //         nseIINDetailsAPI.data.body.iin !== "" &&
        //         nseIINDetailsAPI.data.body.valid_pan_response === "Y" &&
        //         nseIINDetailsAPI.data.body.iin_confirmation_status ===
        //           "Y" &&
        //         nseIINDetailsAPI.data.body
        //           .iin_consolidated_confirmation_status === "Y" &&
        //         nseIINDetailsAPI.data.body.activation_Status === "NO"
        //       ) {
        //         console.log(
        //           nseIINDetailsAPI.data.body.iin_deactivation_reason
        //         );
        //         if (
        //           nseIINDetailsAPI.data.body.iin_deactivation_reason !==
        //             "Cancelled cheque image not available,Name mismatch with KYC" ||
        //           "Cancelled cheque image not available"
        //         ) {
        //           Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
        //             state: {
        //               reason: "Your NSE IIN Account Is Deactivated.",
        //             },
        //           });

        //           console.log("4");
        //         } else {
        //           // Toast.error("Data Passed");
        //           console.log("5");
        //         }
        //       }
        //     }
        //   } else {
        //     if (
        //       nseIINDetailsAPI.data.statusCode === 500 &&
        //       nseIINDetailsAPI.data.errorMessage ===
        //         "IIN Not Available in Dexterr System. Create Customer for this PAN."
        //     ) {
        //       setApiCallsInProgress(apiCallsInProgress - 1);

        //       console.log(nseIINDetailsAPI.data.statusCode);
        //       const CustomerKycDetails = customerKycApiResponse.data.data;
        //       let nomineeOpted = "N";
        //       let no_of_nominee = "0";

        //       // Check if nominee details are present
        //       if (
        //         CustomerKycDetails.nomineeName !== null &&
        //         CustomerKycDetails.nomineeDob !== "1900-01-01" &&
        //         CustomerKycDetails.nomineeRelationShip !== null &&
        //         CustomerKycDetails.nomineeAllocationPercentage !== null
        //       ) {
        //         // If all nominee details are present, set NOMINEE_OPTED to "Y"
        //         nomineeOpted = "Y";
        //         no_of_nominee = "1";
        //       }
        //       console.log(customerKycApiResponse.data.data, "passed");
        //       try {
        //         const postApiResponse = await axios.post(
        //           "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        //           {
        //             nseCreateCustomer: {
        //               title: CustomerKycDetails.title,
        //               inv_name: CustomerKycDetails.fullName,
        //               pan: CustomerKycDetails.pan,
        //               dob: CustomerKycDetails.dob,
        //               addr1: CustomerKycDetails.addressLine1,
        //               addr2: CustomerKycDetails.addressLine2,
        //               city: CustomerKycDetails.city,
        //               state: CustomerKycDetails.state,
        //               pincode: CustomerKycDetails.zip,
        //               country: CustomerKycDetails.country,
        //               mobile_no: CustomerKycDetails.phoneNumber,
        //               email: CustomerKycDetails.emailId,
        //               bank_name: CustomerKycDetails.bankName,
        //               acc_no: CustomerKycDetails.bankAccountNumber,
        //               acc_type: CustomerKycDetails.bankAccountType,
        //               ifsc_code: CustomerKycDetails.bankIfscCode,
        //               branch_name: CustomerKycDetails.bankBranchName,
        //               branch_addr1: CustomerKycDetails.bankBranchAddress,
        //               NOMINEE_OPTED: nomineeOpted,
        //               no_of_nominee: no_of_nominee,
        //               nominee1_name: CustomerKycDetails.nomineeName,
        //               nominee1_dob: CustomerKycDetails.nomineeDob,
        //               nominee1_relation:
        //                 CustomerKycDetails.nomineeRelationShip,
        //               nominee1_percent:
        //                 CustomerKycDetails.nomineeAllocationPercentage,
        //               nominee1_guard_name:
        //                 CustomerKycDetails.nomineeGuardianName,
        //               nominee1_guard_pan:
        //                 CustomerKycDetails.nomineeGuardianPan,
        //             },
        //           },
        //           { headers: headers }
        //         );

        //         if (
        //           postApiResponse.data.status === true &&
        //           postApiResponse.data.statusCode === 200
        //         ) {
        //           console.log("nseCreateCustomer api call");
        //           setApiCallsInProgress(apiCallsInProgress - 1);

        //           if (postApiResponse.data.body.iin) {
        //             const nseIINDetailsAPI = await axios.post(
        //               "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        //               {
        //                 nseIINDetails: {
        //                   pan: panNumber,
        //                 },
        //               }
        //             );
        //             if (
        //               nseIINDetailsAPI.status === 200 &&
        //               nseIINDetailsAPI.data.statusCode === 200
        //             ) {
        //               const nseIINDetailsAPIData = nseIINDetailsAPI.data;
        //               console.log("nseIINDetails api call");
        //               // Toast.success(FristApiResponseData.message);

        //               if (
        //                 nseIINDetailsAPI.data &&
        //                 nseIINDetailsAPI.data.body
        //               ) {
        //                 const {
        //                   iin,
        //                   primary_distributor,
        //                   iin_confirmation_status,
        //                   iin_consolidated_confirmation_status,
        //                   iin_deactivation_reason,
        //                 } = nseIINDetailsAPI.data.body || {};
        //                 dispatch(setIinNumber(iin));

        //                 if (
        //                   nseIINDetailsAPI.data.body.iin !== "" &&
        //                   nseIINDetailsAPI.data.body
        //                     .iin_confirmation_status === "Y" &&
        //                   nseIINDetailsAPI.data.body
        //                     .iin_consolidated_confirmation_status ===
        //                     "Y" &&
        //                   nseIINDetailsAPI.data.body.activation_Status ===
        //                     "YES"
        //                 ) {
        //                   const requestBody = {
        //                     nseFatcaEnquiry: {
        //                       iin: iin,
        //                       pan: panNumber,
        //                     },
        //                   };
        //                   console.log(
        //                     "in nseIIN api frist condition work"
        //                   );
        //                   try {
        //                     const nseFatcaEnquiryresponse =
        //                       await axios.post(
        //                         "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        //                         requestBody
        //                       );

        //                     console.log(
        //                       nseFatcaEnquiryresponse.data.body
        //                     );

        //                     if (
        //                       nseFatcaEnquiryresponse.data.body.status ===
        //                       "Success"
        //                     ) {
        //                       if (
        //                         nseFatcaEnquiryresponse.data.body
        //                           .fatca_reg === "Y" 
        //                           // && nseFatcaEnquiryresponse.data.body
        //                           // .fatca_verify_status === "Y"
        //                       ) {
        //                         console.log(
        //                           "in nseIIN api 1nd condition work"
        //                         );

        //                         Navigate(ROUTE_Purchase_One_Time, {
        //                           state: {
        //                             IIN_Number: iin,
        //                           },
        //                         });
        //                       } else if (
        //                         nseFatcaEnquiryresponse.data.body
        //                           .fatca_reg !== "Y"
        //                       ) {
        //                         console.log(
        //                           "in nseIIN api 2nd condition work"
        //                         );

        //                         const CustomerKycDetailsResponse =
        //                           await axios.get(
        //                             "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",
        //                             {
        //                               headers: {
        //                                 Authorization: `Bearer ${storedToken}`,
        //                                 // RefreshToken: refreshToken,
        //                               },
        //                             }
        //                           );

        //                         const GetAPIData =
        //                           CustomerKycDetailsResponse.data.data;
        //                         const fullname = GetAPIData.fullName;
        //                         dispatch(
        //                           setBankName({
        //                             bankName: GetAPIData.bankName,
        //                           })
        //                         );
        //                         console.log(GetAPIData, "Get api data");

        //                         const FatcaApiResponse = await axios.post(
        //                           "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        //                           {
        //                             nseFatca: {
        //                               mobilenumber: phoneNumber,
        //                               pan: panNumber,
        //                               iin: iin,
        //                               investor_name: fullname,
        //                               app_income_code:
        //                                 GetAPIData.nseIncomeCode,
        //                               occ_code:
        //                                 GetAPIData.nseOccupationCode,
        //                               dob: GetAPIData.dob,
        //                               log_name: GetAPIData.emailId,
        //                               country_of_birth:
        //                                 GetAPIData.nseCountryOfBirth,
        //                               place_birth:
        //                                 GetAPIData.placeOfBirth,
        //                             },
        //                           },
        //                           {
        //                             headers: {
        //                               Authorization: `Bearer ${storedToken}`,
        //                               // RefreshToken: refreshToken,
        //                             },
        //                           }
        //                         );

        //                         if (
        //                           FatcaApiResponse.data.status ===
        //                             "true" &&
        //                           FatcaApiResponse.data.statusCode ===
        //                             200 &&
        //                           FatcaApiResponse.data.body.status ===
        //                             "Success"
        //                         ) {
        //                           console.log(
        //                             "in nseIIN api 3rd condition work"
        //                           );
        //                           setApiCallsInProgress(
        //                             apiCallsInProgress - 1
        //                           );

        //                           const recheckresponse =
        //                             await axios.post(
        //                               "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        //                               requestBody
        //                             );
        //                           const { nseFatcaEnquiryData } =
        //                             recheckresponse.data;
        //                           const { status, nseFatcaEnquiry } =
        //                             nseFatcaEnquiryData;

        //                           if (status === "Success") {
        //                             if (
        //                               nseFatcaEnquiry.fatca_reg === "Y" 
        //                               //&& nseFatcaEnquiry.fatca_verify_status ==="Y"
        //                             ) {
        //                               Navigate(ROUTE_Purchase_One_Time, {
        //                                 state: {
        //                                   IIN_Number: iin,
        //                                 },
        //                               });
        //                             } else if (
        //                               nseFatcaEnquiry.fatca_reg !== "Y"
        //                             ) {
        //                               const FatcaApiResponse =
        //                                 await axios.post(
        //                                   "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        //                                   {
        //                                     nseFatca: {
        //                                       mobilenumber: phoneNumber,
        //                                       pan: panNumber,
        //                                       iin: iin,
        //                                       investor_name: fullname,
        //                                       app_income_code:
        //                                         GetAPIData.nseIncomeCode,
        //                                       occ_code:
        //                                         GetAPIData.nseOccupationCode,
        //                                       dob: GetAPIData.dob,
        //                                       log_name:
        //                                         GetAPIData.emailId,
        //                                       country_of_birth:
        //                                         GetAPIData.nseCountryOfBirth,
        //                                       place_birth:
        //                                         GetAPIData.placeOfBirth,
        //                                     },
        //                                   },
        //                                   {
        //                                     headers: {
        //                                       Authorization: `Bearer ${storedToken}`,
        //                                       // RefreshToken: refreshToken,
        //                                     },
        //                                   }
        //                                 );
        //                             } else if (
        //                               nseFatcaEnquiry.fatca_reg === "Y" 
        //                               // && nseFatcaEnquiry.fatca_verify_status !=="Y"
        //                             ) {
        //                               Navigate(ROUTE_FATCA_CONFIRMATION, {
        //                                 state: {
        //                                   IIN_Number: iin,
        //                                 },
        //                               });
        //                             }
        //                           } else {
        //                             if (status !== "Success") {
        //                               Toast.error(
        //                                 nseFatcaEnquiryresponse.data
        //                                   .errorMessage || "Failed"
        //                               );
        //                               console.log("1");
        //                             }
        //                           }

        //                           // Navigate(ROUTE_Purchase_One_Time);
        //                         } else {
        //                           Toast.error(
        //                             "fetching FATCA details failed"
        //                           );
        //                           console.log("2");
        //                           Navigate(ROUTE_FATCA_Failed);
        //                           setApiCallsInProgress(
        //                             apiCallsInProgress - 1
        //                           );
        //                         }
        //                       }
        //                     } else {
        //                       if (
        //                         nseFatcaEnquiryresponse.body.status !==
        //                         "Success"
        //                       ) {
        //                         Toast.error(
        //                           nseFatcaEnquiryresponse.data
        //                             .errorMessage || "Failed"
        //                         );
        //                         console.log("3");
        //                       }
        //                     }
        //                   } catch (error) {
        //                     console.error("Error:", error);
        //                     // Handle error
        //                   }
        //                   // NseFatcaEnquiryapi();
        //                   console.log("NseFatcaEnquiryapi call");
        //                 } else if (
        //                   (nseIINDetailsAPI.data.body.iin !== "" &&
        //                     nseIINDetailsAPI.data.body
        //                       .valid_pan_response === "Y" &&
        //                     nseIINDetailsAPI.data.body
        //                       .iin_confirmation_status === "Y" &&
        //                     nseIINDetailsAPI.data.body
        //                       .iin_consolidated_confirmation_status ===
        //                       "Y" &&
        //                     nseIINDetailsAPI.data.body
        //                       .activation_Status === "NO" &&
        //                     nseIINDetailsAPI.data.body
        //                       .iin_deactivation_reason ===
        //                       "Cancelled cheque image not available") ||
        //                   "Cancelled cheque image not available,Name mismatch with KYC"
        //                 ) {
        //                   Navigate(ROUTE_UPLOAD_CANCELLED_CHEQUE);
        //                 } else if (
        //                   iin !== "" &&
        //                   primary_distributor !== "Y"
        //                 ) {
        //                   //console.log(
        //                   //   "Condition 1: iin is not empty and primary_distributor is not 'Y'"
        //                   // );
        //                   Navigate(ROUTE_Purchase_One_Time, {
        //                     state: {
        //                       IIN_Number: iin,
        //                     },
        //                   });
        //                 } else if (
        //                   (primary_distributor === "Y" &&
        //                     iin_consolidated_confirmation_status !==
        //                       "Y") ||
        //                   iin_confirmation_status !== "Y"
        //                 ) {
        //                   Navigate(ROUTE_BLANK_TEXT_SCREEN, {
        //                     state: {
        //                       INV_Name:
        //                         customerKycApiResponse.data.body
        //                           .panDetails.inv_name,
        //                     },
        //                   });
        //                 } else if (
        //                   nseIINDetailsAPI.data.body.iin !== "" &&
        //                   nseIINDetailsAPI.data.body
        //                     .valid_pan_response === "Y" &&
        //                   nseIINDetailsAPI.data.body
        //                     .iin_confirmation_status === "Y" &&
        //                   nseIINDetailsAPI.data.body
        //                     .iin_consolidated_confirmation_status ===
        //                     "Y" &&
        //                   nseIINDetailsAPI.data.body.activation_Status ===
        //                     "NO"
        //                 ) {
        //                   if (
        //                     nseIINDetailsAPI.data.body
        //                       .iin_deactivation_reason !==
        //                       "Cancelled cheque image not available,Name mismatch with KYC" ||
        //                     "Cancelled cheque image not available"
        //                   ) {
        //                     Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
        //                       state: {
        //                         reason:
        //                           "Your NSE IIN Account Is Deactivated.",
        //                       },
        //                     });
        //                   } else {
        //                     // Toast.error("Data Passed");
        //                     console.log("5");
        //                   }
        //                 }
        //               }
        //             }
        //           } else {
        //             Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
        //               state: {
        //                 reason: "Your NSE IIN Account Creation Failed.",
        //               },
        //             });
        //           }
        //         } else {
        //           // Toast.error(postApiResponse.data.message);
        //           console.log("6");
        //           Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
        //             state: {
        //               reason: "Your NSE IIN Account Creation Failed.",
        //             },
        //           });
        //           setApiCallsInProgress(apiCallsInProgress - 1);
        //         }
        //         // Toast.error(FristApiResponse.data.errorMessage);
        //         console.log("7");
        //       } catch (error) {
        //         //console.error("Error in POST request:", error);
        //       }
        //     } else {
        //       setApiCallsInProgress(apiCallsInProgress - 1);

        //       Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
        //         state: {
        //           reason: "Unable To Get Your NSE IIN Account Details",
        //         },
        //       });

        //       // Toast.error(nseIINDetailsAPI.data.message);
        //       console.log("8");
        //     }
        //   }
        // }
        else {
          Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
            state: {
              reason: "Please contact Dexterr team for doing your KYC.",
            },
          });

        }
      } else {
        Toast.error(thirdApiResponse.data.message)
      }
    } catch (error) {
      Toast.error(
        error.response.data.errorMessage +
        " " +
        error.response.data.message || "Error"
      );
    }
  };
  const HandleSubmit = () => {

    callAPI();
    // Navigate(ROUTE_EMAIL);
  }



  return (
    <div className="KYC_Rejected_Container">
      <div className="Rjected_KYC_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
      </div>
      <div className="Kyc_Proceed_Container">
        <p className="User_Pan_Name">
          Hey &nbsp; {fullName}!
          <span className="User_Note">You have to do a new KYC before <br />doing Mutual Fund Investments.</span>
          <span className="Forward_msg_text">
            Let's begin with your e-KYC
          </span>
        </p>
        <div className="Input_Filed_Box">
          <span className="Enter_mobile_text">Your PAN Number </span>
          <div className="Input_Inner_Container">
            <input
              className="Input_Filed"
              value={panNumberInput || panNumber}
              onChange={handleInputChange}
              placeholder="eg: CYSP9917D"
              maxLength={10}
              readOnly
            />
            <button
              className="Cross_button"
              onClick={handleClearButtonClick}
            />
          </div>
        </div>
        <button className="proceed_button" onClick={HandleSubmit}>
          {" "}
          proceed{" "}
        </button>
      </div>
    </div>
  );
};
export default KycRejected;